import React, { useState } from 'react';
import { Box, Tab, Tabs, Tooltip, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { useStyles } from './tabComponent.styles';

interface ITabItem {
  label: string;
  icon?: React.ReactElement;
  children?: any;
}
interface ITabComponentProps {
  tabItems: ITabItem[];
  containerStyle?: string;
  tabsRowStyle?: string;
  childrenStyle?: string;
}

const TabComponent = (props: ITabComponentProps) => {
  const { tabItems, containerStyle, tabsRowStyle, childrenStyle } = props;
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:768px)');

  const tabProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const hasIcons = tabItems?.some(({ icon }) => !!icon);
  const showIconsOnly = isMobile && hasIcons;
  const selectedLabel = tabItems?.[value]?.label;

  return (
    <div className={containerStyle}>
      <Tabs
        className={tabsRowStyle}
        value={value}
        TabIndicatorProps={{
          style: {
            color: theme.palette.primary.main,
            background: theme.palette.primary.main,
            borderBottom: '4px solid',
          },
        }}
        indicatorColor="primary"
        scrollButtons="auto"
        variant={isMobile ? 'fullWidth' : 'standard'}
        onChange={handleChange}
      >
        {tabItems?.map(({ label, icon }, index) => {
          const tab = (
            <Tab
              className={classes.tab}
              key={index}
              label={showIconsOnly ? undefined : label}
              icon={showIconsOnly ? icon : undefined}
              {...tabProps(index)}
            />
          );

          if (showIconsOnly) {
            return (
              <Tooltip key={index} title={label} arrow enterTouchDelay={0}>
                {tab}
              </Tooltip>
            );
          }

          return tab;
        })}
      </Tabs>
      {showIconsOnly && selectedLabel && (
        <Typography className={classes.activeLabel}>
          {selectedLabel}
        </Typography>
      )}
      {tabItems?.map(({ children }, index) => (
        <div
          key={`simple-tabpanel-${index}`}
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
        >
          {value === index && <Box className={childrenStyle}>{children}</Box>}
        </div>
      ))}
    </div>
  );
};

export default TabComponent;
